import { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import { IProductPropsPDP } from 'store/modules/product';

import * as S from './styles';

interface SimpleProductCarouselProps {
  items: IProductPropsPDP[];
}

export function SimpleProductCarousel({ items }: SimpleProductCarouselProps) {
  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const breakpoints = {
    820: {
      slidesPerView: items.length > 2 ? 2 : items.length,
      loop: items.length > 2 ? true : false,
      navigation: items.length > 2 ? true : false,
    },
    1024: {
      slidesPerView: items.length > 3 ? 3 : items.length,
      loop: items.length > 3 ? true : false,
      navigation: items.length > 3 ? true : false,
    },
    1470: {
      slidesPerView: items.length > 4 ? 4 : items.length,
      loop: items.length > 4 ? true : false,
      navigation: items.length > 4 ? true : false,
    },
  };

  return (
    <S.Container className="simple-product-carousel simple-swiper">
      <Swiper
        ref={swiperRef}
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={40}
        slidesPerView={2}
        autoplay={{
          delay: 0,
          disableOnInteraction: true,
          reverseDirection: true,
        }}
        loop={items.length > 2 ? true : false}
        navigation={items.length > 2 ? true : false}
        speed={0}
        breakpoints={breakpoints}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index} className="simple-product-carousel-item">
            <a href={`/${item.permalink}`}>
              <img loading="lazy" src={item.imagemUrl} alt={item.nome} />

              <span className="item-name">{item.nome}</span>

              <span className="item-price">{item.precoPorTexto}</span>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      {items.length > 4 && (
        <>
          <div className="swiper-button-prev" onClick={handleNext}></div>
          <div className="swiper-button-next" onClick={handlePrev}></div>
        </>
      )}
    </S.Container>
  );
}
